<template>
  <span
    v-if="visible"
    class="tooltip"
    :data-tooltip="showTooltip ? 'Good' : false"
    :href="item.chocoPackage.GalleryDetailsUrl"
    target="_blank"
  >
    <slot></slot>
  </span>
</template>

<script>
import checks from "@/utils/packageCheck";

export default {
  props: { item: Object, showTooltip: Boolean },
  computed: {
    visible() {
      return (
        checks.hasHealthInfo(this.item) &&
        !checks.hasFailedTests(this.item) &&
        !checks.hasFailedVirusScan(this.item) &&
        !checks.hasFailedValidations(this.item) &&
        !checks.isNotApproved(this.item)
      );
    }
  }
};
</script>
